export default __webpack_public_path__ + "static/media/mateusSouza.a60a3ca8.jpg";